/**
 * @generated SignedSource<<4771e4f74f05cd161719606dcfd15df6>>
 * @relayHash 3d21dc49fbb64d7d8c34effe9fb16eb7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e310b7db938b585ff3b36bd945b794c3be38b351eff52448c1b569b39a39a434

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type StatuspageDetailsPageDraftQuery$variables = {
  pageId: string;
};
export type StatuspageDetailsPageDraftQuery$data = {
  readonly stakeholderComms_getDraftPageById: {
    readonly error: string | null | undefined;
    readonly page: {
      readonly name: string;
      readonly " $fragmentSpreads": FragmentRefs<"StatuspageDraftDetails">;
    } | null | undefined;
  } | null | undefined;
};
export type StatuspageDetailsPageDraftQuery = {
  response: StatuspageDetailsPageDraftQuery$data;
  variables: StatuspageDetailsPageDraftQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pageId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "pageId",
    "variableName": "pageId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "error"
},
v3 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "StatuspageDetailsPageDraftQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "StakeholderCommsPageResponse",
        "kind": "LinkedField",
        "name": "stakeholderComms_getDraftPageById",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "StakeholderCommsPage",
            "kind": "LinkedField",
            "name": "page",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "FragmentSpread",
                "name": "StatuspageDraftDetails"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StatuspageDetailsPageDraftQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "StakeholderCommsPageResponse",
        "kind": "LinkedField",
        "name": "stakeholderComms_getDraftPageById",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "StakeholderCommsPage",
            "kind": "LinkedField",
            "name": "page",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "kind": "ScalarField",
                "name": "subdomain"
              },
              {
                "kind": "ScalarField",
                "name": "description"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "e310b7db938b585ff3b36bd945b794c3be38b351eff52448c1b569b39a39a434",
    "metadata": {},
    "name": "StatuspageDetailsPageDraftQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9be7e1b8ce7d4f0c842a512e838b8673";

export default node;
